var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 46,
    viewBox: "0 0 60 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(512 -528.5) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    d: "M5,0H5a5,5,0,0,1,5,5V60a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(564.5 452)",
    fill: "#bf0a76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    d: "M5,0H5a5,5,0,0,1,5,5V50a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(546.5 462)",
    fill: "#bf0a76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    d: "M5,0H5a5,5,0,0,1,5,5V40a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(528.5 472)",
    fill: "#bf0a76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    d: "M5,0H5a5,5,0,0,1,5,5V44a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(564.5 468)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    d: "M5,0H5a5,5,0,0,1,5,5V36a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(546.5 476)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    d: "M5,0H5a5,5,0,0,1,5,5V31a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(528.5 481)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    d: "M5,0H5a5,5,0,0,1,5,5V32a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(564.5 480)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    d: "M5,0H5a5,5,0,0,1,5,5V20a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(546.5 492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    d: "M5,0H5a5,5,0,0,1,5,5v8a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(528.5 499)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart8);
export default __webpack_public_path__ + "static/media/chart8.56e0e51a75d9a413c466134d301ddfbc.svg";
export { ForwardRef as ReactComponent };